import { defineStore } from "pinia";
import { ref, computed } from "vue";
import { getStore, setStore } from "@/utils";

const useAIChatStore = defineStore("aiChat", () => {
  // 所有时区，数据存在localStorage
  const chatMap = ref(getStore({ name: "aiChat" }) || {});

  //当前会话id
  const currentSessionId = ref<string>("");

  const currentUseSessionId: any = computed(() => currentSessionId.value);

  const currentModel = ref<string>("deepseek-v3");

  // 当前使用模型
  const currentUseModel = computed(() => currentModel.value);

  // 设置当前使用模型
  const setCurrentUseModel = (model: string) => {
    currentModel.value = model;
  };

  // 设置会话当前id
  const setCurrentSessionId = (sId: string) => {
    currentSessionId.value = sId;
  };

  const studyAgent = ref<{ agent_name: string; agent_icon: string }>();

  const currentStudyAgent = computed(() => studyAgent.value);

  const setCurrentStudyAgent = (val: { agent_name: string; agent_icon: string }) => {
    studyAgent.value = val;
  };

  // 设置所有时区数据（暂时无用）
  const setChatMap = (data: any) => {
    chatMap.value = data;
    setStore({
      name: "aiChat",
      content: chatMap.value,
    });
  };

  interface RoleInfoData {
    name: string;
    icon: string;
    desc: string;
  }

  // 当前角色信息
  const roleInfo = ref({} as RoleInfoData);

  const currentRoleInfo = computed(() => roleInfo.value);

  const setCurrentRoleInfo = (data: RoleInfoData) => {
    roleInfo.value = data;
  };

  const agentInfo = ref<{ name: string; icon: string } | undefined>();
  const currentAgentInfo = computed(() => agentInfo.value);

  const setCurrentAgentInfo = (data: any) => {
    agentInfo.value = data;
  };

  return {
    chatMap,
    setChatMap,
    currentUseSessionId,
    setCurrentSessionId,
    currentUseModel,
    setCurrentUseModel,
    currentRoleInfo,
    setCurrentRoleInfo,
    currentAgentInfo,
    setCurrentAgentInfo,

    currentStudyAgent,
    setCurrentStudyAgent
  };
});

export default useAIChatStore;
